module.exports = __webpack_public_path__ + "img/s10on.83f31286.svg";